import { render, staticRenderFns } from "./router-question.vue?vue&type=template&id=9288b1be&"
import script from "./router-question.vue?vue&type=script&lang=js&"
export * from "./router-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports